export const API_URL = "https://admin.bumiagungpodomoro.co.id/wp/wp-json/wp/v2";
